module.exports = require('./lib/components/EllipsisText');



//////////////////
// WEBPACK FOOTER
// ./~/react-ellipsis-text/index.js
// module id = 351
// module chunks = 0